export enum QuestionTypes {
    multiChoice = 0,
    fillInTheBlank = 1,
    matchTheTerms = 2,
    wordBucket = 3,
    imageMatch = 4,
    statementBlanking = 5,
    crossword = 6
}